<template>
  <div class="flex justify-between space-x-3">
    <div class="w-1/4 bg-dash-green boxes pt-5 pb-3 px-3 rounded-md">
      <p class="text-white font-light text-sm">
        SUCCESSFUL TRANSACTION AS AT TODAY
      </p>
      <div class="flex justify-between">
        <div class="mt-3">
          <p class="text-white font-bold text-3xl">
            {{ formatMoney(totalAmount.success) }}
          </p>
          <p class="text-white font-bold mt-3">
            COUNT - {{ totalCount.success }}
          </p>
        </div>
        <div class="mt-4">
          <i class="fa fa-globe text-4xl text-green-light"></i>
        </div>
      </div>
    </div>

    <div class="w-1/4 bg-dash-red boxes pt-5 pb-3 px-3 rounded-md">
      <p class="text-white font-light text-sm">
        FAILED TRANSACTION AS AT TODAY
      </p>
      <div class="flex justify-between">
        <div class="mt-3">
          <p class="text-white font-bold text-3xl">
            {{ formatMoney(totalAmount.failed) }}
          </p>
          <p class="text-white font-bold mt-3">
            COUNT - {{ totalCount.failed }}
          </p>
        </div>
        <div class="mt-4">
          <i class="fa fa-exclamation-triangle text-4xl text-red-light"></i>
        </div>
      </div>
    </div>

    <div class="w-1/4 bg-blue-dark boxes rounded pt-1">
      <div id="chart">
        <apexchart
          type="pie"
          height="152"
          :options="pieOptions1"
          :series="pieSeries1"
        ></apexchart>
      </div>
    </div>

    <div class="w-1/4 bg-blue-500 boxes pt-5 pb-3 px-3 rounded-md">
      <p class="text-white font-light text-sm">
        TOTAL TRANSACTION YEAR TO DATE
      </p>
      <div class="flex justify-between">
        <div class="mt-3">
          <p class="text-white font-bold text-2xl">
            {{ formatMoney(totalAmountYear) }}
          </p>
          <p class="text-white font-bold mt-3">COUNT - {{ totalCountYear }}</p>
        </div>
        <div class="mt-4">
          <i class="fa fa-globe text-4xl text-blue-600"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxPieCharts",
  props: {
    bg_line: String,
    totalAmount: Object,
    totalCount: Object,
    groupSuccess: Object,
    totalAmountYear: {
      type: Number,
      default: 0,
    },
    totalCountYear: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      pieOptions1: {
        chart: {
          type: "pie",
          foreColor: "#e6e6e6",
          offsetX: 0,
        },
        labels: this.groupSuccess.labels,
        theme: {
          monochrome: {
            enabled: false,
            color: "#0033cc",
            shadeIntensity: 0.65,
          },
        },
        stroke: {
          width: 0,
        },
        legend: {
          position: "left",
          fontSize: "8px",
          markers: {
            width: 7,
            height: 7,
          },
        },
        title: {
          text: "INSTITUTIONS SUCCESSFUL TRANSACTION COUNT",
          floating: false,
          style: {
            fontSize: "11px",
            fontWeight: "thin",
            cssClass: "break-words",
          },
        },
      },
      pieSeries1: this.groupSuccess.counts,
    };
  },
  methods: {
    formatMoney(amt) {
      return "₦" + Number(amt).toLocaleString();
    },
  },
};
</script>
<style scoped>
.boxes {
  /* height: 189px; */
  max-height: 163px !important;
}
</style>
